// Error boundary raiz do router: cobre toda rota que não declara um
// `errorElement` próprio (login, cadastro público, magic link, fluxos de
// vistoria). Sem ele o React Router pinta sua tela default "Unexpected
// Application Error!" com o stack trace cru.
//
// Erro de bundle stale não chega a ser exibido: a página se recarrega sozinha
// na versão publicada (useStaleBundleRecovery). A tela abaixo é o que sobra —
// erro de render genuíno, ou bundle stale que já não cede a reload.

import { useTranslation } from 'react-i18next';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';

import { Button } from '@alamo/ui';

import { isStaleBundleError } from '../lib/staleBundleRecovery';
import { useStaleBundleRecovery } from '../lib/useStaleBundleRecovery';

import { BundleUpdatingScreen } from './BundleUpdatingScreen';

export function AppErrorBoundary(): JSX.Element {
  const error = useRouteError();
  const { t } = useTranslation(['common', 'ui']);
  const recovering = useStaleBundleRecovery(error);

  if (recovering) return <BundleUpdatingScreen />;

  // Bundle stale que chegou até aqui já não cede a reload automático: o texto
  // pede a ação em vez de falar em erro do sistema.
  const stale = isStaleBundleError(error);
  const title = stale ? t('ui:pwa.stale_title') : t('common:messages.unexpected_error');
  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : t('ui:pwa.stale_hint');

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-alamo-bg p-6">
      <div className="max-w-md text-center">
        <div className="mb-4 text-5xl" aria-hidden="true">
          &#9888;&#65039;
        </div>
        <h1 className="mb-2 text-xl font-heading font-semibold text-secondary-950">{title}</h1>
        <p className="mb-6 text-sm font-body text-slate-600">{detail}</p>
        <Button variant="primary" onClick={() => window.location.reload()}>
          {t('ui:pwa.chunk_stale_action')}
        </Button>
      </div>
    </div>
  );
}
